import { apiRequest, DataReturnType, HttpMethods } from "@alba-cars/common-modules";

interface UpdateBankValuationInspectionPayload {
  requiresInspection: boolean;
  status: "booked";
  inspectionType: "alba" | "home";
  inspectionDate: string;
  scheduledAtUtc: string;
  addressText: string;
  googleMapsPinUrl: string;
  timezone: string;
  timeSlotCode: string;
}

export const updateBankValuationInspection = async (
  valuationId: string,
  payload: UpdateBankValuationInspectionPayload,
) => {
  return apiRequest<DataReturnType<unknown>>(`/bank-valuation-request/${valuationId}/inspection`, {
    method: HttpMethods.PUT,
    body: JSON.stringify(payload),
  });
};
